import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import api from "../../api/axios";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { ErroContainer } from "../../styles/GlobalStyles";
import { toast } from "react-toastify";

export const EditCooperativeModal = ({
  open,
  onClose,
  professionalData,
  mode,
  cooperative,
}) => {
  const [values, setValues] = useState({
    _id: "",
    professional: "",
    registration: "",
    profession: "",
    start_date: null,
    end_date: null,
  });

  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    const isFormValid = Object.values(values).every((v) => v !== "");

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    const registrationExists = await api.post(
      "/cooperative/check-registration",
      { registration: values.registration, id: values._id },
    );

    if (registrationExists.data.result) {
      setError("Este número de matrícula já existe");
      return;
    }

    values.start_date = new Date(values.start_date);
    if (values.end_date) values.end_date = new Date(values.end_date);

    try {
      await api.put(`/cooperative/update/${values._id}`, values);
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/cooperative/delete/${values._id}`);
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleClose = () => {
    resetValues();
    setError("");
    onClose();
  };

  const resetValues = () => {
    setValues({
      _id: "",
      professional: "",
      registration: "",
      profession: "",
      start_date: null,
      end_date: null,
    });
  };

  useEffect(() => {
    if (
      cooperative &&
      Array.isArray(professionalData) &&
      professionalData.length > 0
    ) {
      setValues({
        ...cooperative,
        professional: cooperative.professional?.toString() || "",
        start_date: cooperative.start_date
          ? dayjs(cooperative.start_date)
          : null,
        end_date: cooperative.end_date ? dayjs(cooperative.end_date) : null,
      });
    }
  }, [cooperative, professionalData]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">{`${
        mode === "edit" ? "Editar" : "Deseja remover este"
      } Cooperado${
        mode === "delete" ? "? (Essa ação é irreversível)" : ""
      }`}</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: "100%",
            minWidth: "300px",
            gap: "1.5rem",
          }}
        >
          <FormControl>
            <InputLabel id="type">Profissional</InputLabel>
            <Select
              id="type"
              name="type"
              value={values.professional}
              defaultValue={values.professional}
              onChange={(e) => {
                setValues({ ...values, professional: e.target.value });
                setError("");
              }}
              disabled={mode === "delete"}
            >
              {Array.isArray(professionalData) ? (
                professionalData?.map((professional) => (
                  <MenuItem
                    key={professional._id}
                    value={professional?._id}
                  >{`${professional?.name} (${professional?.cpf})`}</MenuItem>
                ))
              ) : (
                <></>
              )}
            </Select>
          </FormControl>
          <TextField
            label="Número de matrícula"
            id="registration"
            name="registration"
            type="text"
            value={values.registration}
            disabled={mode === "delete"}
            onChange={(e) => {
              setValues({ ...values, registration: e.target.value });
              setError("");
            }}
          />
          <TextField
            label="Profissão"
            id="profession"
            name="profession"
            type="text"
            value={values.profession}
            disabled={mode === "delete"}
            onChange={(e) => {
              setValues({ ...values, profession: e.target.value });
              setError("");
            }}
          />
          <DatePicker
            label="Início de vigência"
            value={values.start_date}
            disabled={mode === "delete"}
            onChange={(value) => {
              setValues({ ...values, start_date: value });
              setError("");
            }}
          />
          <DatePicker
            label="Fim de vigência"
            value={values.end_date}
            disabled={mode === "delete"}
            onChange={(value) => {
              setValues({ ...values, end_date: value });
              setError("");
            }}
          />
        </Stack>
        <ErroContainer>{error ? error : ""}</ErroContainer>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          onClick={mode === "edit" ? handleSubmit : handleDelete}
          variant="contained"
        >
          {mode === "delete" ? "Confirmar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
